import React from "react";
import Navigation from "./Navbar";
import Footer from "./Footer";

import asso1 from "../image/asso1.jpeg";
import asso2 from "../image/asso2.jpeg";
import asso3 from "../image/asso3.jpeg";
import asso4 from "../image/asso4.jpeg";
import asso5 from "../image/asso5.jpeg";
import asso6 from "../image/asso6.jpeg";
import asso7 from "../image/asso7.jpeg";
import asso8 from "../image/asso8.jpeg";
import asso9 from "../image/asso9.jpeg";

const associations = [
  asso1,
  asso2,
  asso3,
  asso4,
  asso5,
  asso6,
  asso7,
  asso8,
  asso9,
];

const Association = () => {
  return (
    <div className="bg-white min-h-screen">
      {/* Navbar */}
      <div className="fixed top-0 left-0 w-full bg-white shadow-md z-50">
        <Navigation />
      </div>

      {/* Page Content */}
      <main className="pt-[160px] pb-20 px-6 md:px-16">
        
        {/* Heading */}
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-blue-900 mb-4">
            Our <span className="text-orange-600">Associations</span>
          </h1>
          <p className="text-gray-600 max-w-2xl mx-auto">
            We collaborate with leading healthcare, innovation, and industry
            organizations to strengthen research, technology, and healthcare
            ecosystem development.
          </p>
        </div>

        {/* Association Logos Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-10 items-center">
          {associations.map((img, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition duration-300 flex items-center justify-center"
            >
              <img
                src={img}
                alt={`association-${index}`}
                className="h-24 object-contain grayscale hover:grayscale-0 transition duration-300"
              />
            </div>
          ))}
        </div>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Association;